export default {
      id: "notifications__video-event-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#notifications__video-event",
      toString: function () {
        return this.url;
      }
    }